import { render, staticRenderFns } from "./dashboardTabbedContentBox.vue?vue&type=template&id=2df8cf94&"
import script from "./dashboardTabbedContentBox.vue?vue&type=script&lang=js&"
export * from "./dashboardTabbedContentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports